// Bundle the Builder mode content pack, validated through Zod at import time.
// JSON imports work natively in Vite/Vitest and in TS via resolveJsonModule.

import tuning from './tuning.json' with { type: 'json' };
import businesses from './businesses.json' with { type: 'json' };
import assets from './assets.json' with { type: 'json' };
import liabilities from './liabilities.json' with { type: 'json' };
import events from './events.json' with { type: 'json' };
import skills from './skills.json' with { type: 'json' };
import quests from './quests.json' with { type: 'json' };
import { composeBuilderContent } from '../../src/config/load.js';

export const builderContent = composeBuilderContent({
  tuning,
  businesses,
  assets,
  liabilities,
  events,
  skills,
  quests,
});
